import {useRef, useEffect} from 'react'
import {getPlaceHolderImage} from '../../../utils/helpers'
import {checkElement} from '../../../utils/drawing'
import {select} from 'd3-selection'

let isMarkerDisplayed = false

export const removeAllMarkers = ({svgElement}) => {
  isMarkerDisplayed = false
  let markers = document.querySelectorAll("*[id^=\"outer_g\"]")
  markers.forEach(marker => {
    marker.remove()
  })

  let patternDefs = document.querySelectorAll("*[id^=\"pattern_def_1\"]")
  patternDefs.forEach(patternDef => {
    patternDef.remove()
  })
}

export const removeMarker = ({svgElement}) => {
  isMarkerDisplayed = false
  let marker = select(svgElement).selectAll('#outer_g')
  if (!marker.empty()) {
    marker.remove()
  }

  let patternDef = select(svgElement).selectAll('#pattern_def_1')
  if (!patternDef.empty()) {
    patternDef.remove()
  }
}

export const removeOneMarker = ({svgElement, markerElementId}) => {
  isMarkerDisplayed = false
  let marker = select(svgElement).selectAll('#outer_g'+markerElementId)
  if (!marker.empty()) {
    marker.remove()
  }

  let patternDef = select(svgElement).selectAll('#pattern_def_1'+markerElementId)
  if (!patternDef.empty()) {
    patternDef.remove()
  }
}

export const showMarker = ({marker, svgElement, eqDesc, svgScale}) => {

  isMarkerDisplayed = true

  let url = marker.url ? marker.url : getPlaceHolderImage('employee')
  
//  removeMarker({svgElement})
  if(typeof marker.elementId =="number"){
	  marker.elementId = marker.elementId.toString()
  }
  
  let markerId = marker.elementId.replace(/;/g, "")
  removeOneMarker({svgElement: svgElement, markerElementId: markerId})

  let svg = select(svgElement)
  
	let svgHoverScale = svgScale * 1.5
	let xAdj = 50 * svgScale
	let yAdj = 7 * svgScale
	let xAdjHov = 25 * svgScale
	let yAdjHov = 3.5 * svgScale
	

  let eqId = marker.eqId
  let rmAsset = null
  let markerTitle = eqDesc
  let eqAsset = document.getElementById(eqId)
  let x = null
  let y = null
  if (eqAsset) {
	x = Number(eqAsset.getAttribute('x'))
	y = Number(eqAsset.getAttribute('y'))
	let eqbbox = eqAsset.getBBox()
	let eqscale = eqAsset.getAttribute('transform')
	if(eqscale){
		let xyscale = /scale\(\s*([^\s,)]+)[ ,]([^\s,)]+)/.exec(eqscale)
		x = (x + (eqbbox.width / 2))* xyscale[1]
		y = (y - (eqbbox.height / 2)) * xyscale[2]
	}
	else{
		x = x + (eqbbox.width / 2)
		y = y - (eqbbox.height / 2)
	}
//	x = x - 201
//	y = y - 29
  }
  else {
	rmAsset = document.getElementById("l-rm-" + marker.elementId)
	markerTitle += "\n" + "Floor " + marker.elementId.split(";")[1] + ", Room " + marker.elementId.split(";")[2]
  }
	if (rmAsset) {
		let bbox = rmAsset.getAttribute('transform')
		let xy = /translate\(\s*([^\s,)]+)[ ,]([^\s,)]+)/.exec(bbox)
		x = xy[1]
		y = xy[2]
	}
	
  if(rmAsset || eqAsset){
    // TODO: Check if exists before adding
    svg
      .append('defs')
      .attr('id', 'pattern_def_1'+markerId)
      .append('pattern')
      .attr('id', 'marker'+markerId)
      .attr('patternUnits', 'userSpaceOnUse')
      .attr('width', 100)
      .attr('height', 100)
      .append('image')
      .attr('id', 'locate_image')
      .attr('xlink:href', url)
      .attr('width', 100)
      .attr('height', 100)
      .attr('preserveAspectRatio', 'none')

    const g = svg.select('#viewer')
    let container = g.append('g').attr('id', 'outer_g'+markerId).attr('aria-label', eqDesc).attr('aria-describedby','title' + markerId)
	container
	  .on("mouseover", function(){
		  svg.select('#outer_g'+markerId).attr('transform', 'translate(' + (x - xAdjHov - xAdj) + ',' + (y - yAdjHov - yAdj) + ') scale(' + svgHoverScale + ')')
//		  svg.select('#outer_g'+markerId).attr('transform', 'translate(' + x + ',' + y + ')').attr('height', '60px')
		  this.parentNode.appendChild(this);
	  })
	  .on("mouseout", function(){
		  svg.select('#outer_g'+markerId).attr('transform', 'translate(' + (x - xAdj) + ',' + (y - yAdj) + ') scale(' + svgScale + ')')
//		  svg.select('#outer_g'+markerId).attr('transform', 'translate(' + x + ',' + y + ')').attr('height', '40px')
	  })
	  /* 
	  .on("load", function(){
		  svg.select('#outer_g'+markerId).attr('transform', 'translate(' + (x-xAdj) + ',' + (y-yAdj) + ') scale(' + svgScale + ')')
	  })
	   */
	  
	container
	  .append('title')
	  .attr('id', 'title' + markerId)
	  .text(markerTitle)
	  
    container
      .append('path')
	  .attr('id', 'path' + markerId)
      .attr(
        'd',
        'M50.5,7.073 L73.5,30 L70.419,27.755 C80.675,34.389 86.299,45.784 86.604,57.823 C86.604,77.762 70.44,93.927 50.5,93.927 C30.56,93.927 14.396,77.762 14.396,57.823 C14.423,45.681 20.569,34.518 30.581,27.755 L27.5,30 L50.5,7.073 z'
      )
      .attr('fill', '#282d41')

    container
      .append('circle')
      .attr('r', '50')
      .attr('cx', '50')
      .attr('cy', '50')
      .attr('fill', "url(#marker" + markerId + ")")
      .attr('transform', 'translate(0,10)scale(0.60)translate(35,30)')

    container.attr('transform', 'translate(' + (x - xAdj) + ',' + (y - yAdj) + ') scale(' + svgScale + ')')

    let filter = svg
      .select('#pattern_def_1'+markerId)
      .append('filter')
      .attr('id', 'f1')
      .attr('x', '0')
      .attr('y', '0')
      .attr('width', '200%')
      .attr('height', '200%')
    filter
      .append('feOffset')
      .attr('result', 'offOut')
      .attr('in', 'SourceGraphic')
      .attr('dx', '5')
      .attr('dy', '5')
    filter
      .append('feColorMatrix')
      .attr('result', 'matrixOut')
      .attr('in', 'offOut')
      .attr('type', 'matrix')
      .attr('values', '0.2 0 0 0 0 0 0.2 0 0 0 0 0 0.2 0 0 0 0 0 1 0')
    filter
      .append('feGaussianBlur')
      .attr('result', 'blurOut')
      .attr('in', 'matrixOut')
      .attr('stdDeviation', '3')
    filter
      .append('feBlend')
      .attr('in', 'SourceGraphic')
      .attr('in2', 'blurOut')
      .attr('mode', 'normal')

    svg.select('#outer_g'+markerId).attr('filter', 'url(#f1)')
  }
}

export const useMarker = ({marker, svgElement, isLoaded}) => {
  const {show, elementId} = marker

  useEffect(
    () => {
      if (show) {
        if (!isMarkerDisplayed) {
          checkElement(elementId).then(
            () => {
              showMarker({marker, svgElement: svgElement})
            },
            () => {
              console.log('Element not found.')
            }
          )
        }
      } else {
        removeMarker({svgElement: svgElement})
      }
    },
    [marker, isLoaded, elementId, show, svgElement]
  )
}
